export const TARGETS_EN = {
    'nav.module.targets': 'Targets',
    'nav.targets.targets': 'Targets',
    // ── the list ──
    'targets.targets.title': 'Targets',
    'targets.targets.lede': 'What each member, team or the whole workspace is to reach on what your modules count, by month, quarter or year.',
    'targets.targets.empty': 'No target yet: set what a member, a team or the workspace is to reach.',
    'targets.col.metric': 'Metric',
    'targets.col.subject': 'For',
    'targets.col.subject_kind': 'Kind',
    'targets.col.period_start': 'Starts on',
    'targets.col.period_end': 'Ends on',
    'targets.col.amount': 'Target',
    'targets.col.period': 'Period',
    'targets.col.status': 'Status',
    'targets.col.metric_key': 'Metric key',
    'targets.col.subject_ref': 'Reference',
    'targets.col.id': 'Id',
    'targets.col.can_edit': 'Can be changed',
    'targets.col.can_retire': 'Can be retired',
    'targets.col.can_restore': 'Can be restored',
    'targets.subject_kind.workspace': 'The whole workspace',
    'targets.subject_kind.member': 'Member',
    'targets.subject_kind.team': 'Team',
    'targets.subject_kind.other': 'Other',
    'targets.period.month': 'Month',
    'targets.period.quarter': 'Quarter',
    'targets.period.year': 'Year',
    'targets.status.active': 'In force',
    'targets.status.retired': 'Retired',
    // ── the form ──
    'targets.action.create': 'New target',
    'targets.action.edit': 'Change',
    'targets.action.retire': 'Retire',
    'targets.action.restore': 'Restore',
    'targets.field.metric': 'Metric',
    'targets.field.metric.help': 'What your modules count that a target can be set for.',
    'targets.field.subject': 'For',
    'targets.field.subject.help': 'A member or a team. Leave it empty for the whole workspace.',
    'targets.field.period': 'Period',
    'targets.field.period_start': 'Starts on',
    'targets.field.period_start.help': 'The first day of the month, of the quarter or of the year.',
    'targets.field.amount': 'Target',
    'targets.field.amount.help': 'What is to be reached in the period: an amount, a count or a percentage, as the metric counts.',
    // ── refusals ──
    'targets.refusal.not_found': 'This target is not in this workspace.',
    'targets.refusal.taken': 'This metric already has a target for this subject and period. Change it, or restore it if it was retired.',
    'targets.refusal.metrics_unavailable': 'The metrics could not be read now. Try again in a moment.',
    'targets.refusal.metric_unknown': 'No module of this workspace counts this metric now.',
    'targets.refusal.metric_required': 'Choose the metric.',
    'targets.refusal.metric': 'Choose the metric from the list.',
    'targets.refusal.metric_fixed': 'The metric of a target does not change. Set a new target.',
    'targets.refusal.subject': 'Choose a member or a team from the list, or leave it empty for the whole workspace.',
    'targets.refusal.subject_fixed': 'Who a target is for does not change. Set a new target.',
    'targets.refusal.period_required': 'Choose the period.',
    'targets.refusal.period': 'The period is a month, a quarter or a year.',
    'targets.refusal.period_start_required': 'Choose the day the period starts.',
    'targets.refusal.period_start_month': 'A month starts on its first day.',
    'targets.refusal.period_start_quarter': 'A quarter starts on the first of January, April, July or October.',
    'targets.refusal.period_start_year': 'A year starts on the first of January.',
    'targets.refusal.day': 'Write the date as a day of the calendar.',
    'targets.refusal.amount_required': 'Write the target.',
    'targets.refusal.amount': 'The target is a number with at most two decimals, not negative.',
    'targets.refusal.status_route': 'A target is retired and restored on its own, not with the other fields.',
    'targets.refusal.status': 'The status is in force or retired.',
    'targets.refusal.retired': 'Restore this target before changing it.',
    'targets.refusal.stale': 'Someone changed this target since you opened it. Open it again to see their change.',
    'targets.refusal.version': 'The version is the one the target was read at.',
    'targets.refusal.at_required': 'Name the day the target is asked for.',
    'targets.refusal.not_yours': 'You can see your own targets, your teams\' and the workspace\'s.',
    // ── what the change record keeps ──
    'change.field.target.metric': 'Metric',
    'change.field.target.subject_ref': 'For',
    'change.field.target.period': 'Period',
    'change.field.target.period_start': 'Starts on',
    'change.field.target.amount': 'Target',
    'change.field.target.status': 'Status',
    'change.field.target.retired_at': 'Retired',
    'change.field.target.retired_by': 'Retired by',
    'change.field.target.created_by': 'Set by',
};
export const TARGETS_AR = {
    'nav.module.targets': 'الأهداف',
    'nav.targets.targets': 'الأهداف',
    // ── the list ──
    'targets.targets.title': 'الأهداف',
    'targets.targets.lede': 'ما على كل عضو أو فريق أو مساحة العمل كلها بلوغه فيما تعدّه وحداتك، بالشهر أو الربع أو السنة.',
    'targets.targets.empty': 'لا هدف بعد: حدّد ما على عضو أو فريق أو مساحة العمل بلوغه.',
    'targets.col.metric': 'المقياس',
    'targets.col.subject': 'لمن',
    'targets.col.subject_kind': 'النوع',
    'targets.col.period_start': 'تبدأ في',
    'targets.col.period_end': 'تنتهي في',
    'targets.col.amount': 'الهدف',
    'targets.col.period': 'الفترة',
    'targets.col.status': 'الحالة',
    'targets.col.metric_key': 'مفتاح المقياس',
    'targets.col.subject_ref': 'المرجع',
    'targets.col.id': 'المعرّف',
    'targets.col.can_edit': 'يمكن تغييره',
    'targets.col.can_retire': 'يمكن إيقافه',
    'targets.col.can_restore': 'يمكن استعادته',
    'targets.subject_kind.workspace': 'مساحة العمل كلها',
    'targets.subject_kind.member': 'عضو',
    'targets.subject_kind.team': 'فريق',
    'targets.subject_kind.other': 'غير ذلك',
    'targets.period.month': 'شهر',
    'targets.period.quarter': 'ربع سنة',
    'targets.period.year': 'سنة',
    'targets.status.active': 'سارٍ',
    'targets.status.retired': 'موقوف',
    // ── the form ──
    'targets.action.create': 'هدف جديد',
    'targets.action.edit': 'تغيير',
    'targets.action.retire': 'إيقاف',
    'targets.action.restore': 'استعادة',
    'targets.field.metric': 'المقياس',
    'targets.field.metric.help': 'ما تعدّه وحداتك ويمكن تحديد هدف له.',
    'targets.field.subject': 'لمن',
    'targets.field.subject.help': 'عضو أو فريق. اتركه فارغاً لمساحة العمل كلها.',
    'targets.field.period': 'الفترة',
    'targets.field.period_start': 'تبدأ في',
    'targets.field.period_start.help': 'أول يوم من الشهر أو الربع أو السنة.',
    'targets.field.amount': 'الهدف',
    'targets.field.amount.help': 'ما يُراد بلوغه في الفترة: مبلغ أو عدد أو نسبة، كما يعدّه المقياس.',
    // ── refusals ──
    'targets.refusal.not_found': 'هذا الهدف ليس في مساحة العمل هذه.',
    'targets.refusal.taken': 'لهذا المقياس هدف لهذا الطرف وهذه الفترة. غيّره، أو استعده إن كان موقوفاً.',
    'targets.refusal.metrics_unavailable': 'تعذّرت قراءة المقاييس الآن. حاول بعد قليل.',
    'targets.refusal.metric_unknown': 'لا تعدّ أي وحدة في مساحة العمل هذا المقياس الآن.',
    'targets.refusal.metric_required': 'اختر المقياس.',
    'targets.refusal.metric': 'اختر المقياس من القائمة.',
    'targets.refusal.metric_fixed': 'لا يتغيّر مقياس الهدف. حدّد هدفاً جديداً.',
    'targets.refusal.subject': 'اختر عضواً أو فريقاً من القائمة، أو اتركه فارغاً لمساحة العمل كلها.',
    'targets.refusal.subject_fixed': 'لا يتغيّر من وُضع له الهدف. حدّد هدفاً جديداً.',
    'targets.refusal.period_required': 'اختر الفترة.',
    'targets.refusal.period': 'الفترة شهر أو ربع سنة أو سنة.',
    'targets.refusal.period_start_required': 'اختر يوم بدء الفترة.',
    'targets.refusal.period_start_month': 'يبدأ الشهر في يومه الأول.',
    'targets.refusal.period_start_quarter': 'يبدأ الربع في أول يناير أو أبريل أو يوليو أو أكتوبر.',
    'targets.refusal.period_start_year': 'تبدأ السنة في أول يناير.',
    'targets.refusal.day': 'اكتب التاريخ يوماً من التقويم.',
    'targets.refusal.amount_required': 'اكتب الهدف.',
    'targets.refusal.amount': 'الهدف رقم بخانتين عشريتين على الأكثر، وليس سالباً.',
    'targets.refusal.status_route': 'يُوقف الهدف ويُستعاد وحده، لا مع بقية الحقول.',
    'targets.refusal.status': 'الحالة سارٍ أو موقوف.',
    'targets.refusal.retired': 'استعد هذا الهدف قبل تغييره.',
    'targets.refusal.stale': 'غيّر أحدهم هذا الهدف بعد أن فتحته. افتحه من جديد لترى تغييره.',
    'targets.refusal.version': 'الإصدار هو الذي قُرئ عليه الهدف.',
    'targets.refusal.at_required': 'حدّد اليوم المطلوب هدفه.',
    'targets.refusal.not_yours': 'ترى أهدافك وأهداف فرقك وأهداف مساحة العمل.',
    // ── what the change record keeps ──
    'change.field.target.metric': 'المقياس',
    'change.field.target.subject_ref': 'لمن',
    'change.field.target.period': 'الفترة',
    'change.field.target.period_start': 'تبدأ في',
    'change.field.target.amount': 'الهدف',
    'change.field.target.status': 'الحالة',
    'change.field.target.retired_at': 'أُوقف',
    'change.field.target.retired_by': 'أوقفه',
    'change.field.target.created_by': 'حدّده',
};
//# sourceMappingURL=i18n-targets.js.map